import { useContext } from "react";
import { Tooltip } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { QRCode } from 'react-qrcode-logo';

import { LayoutContext, ILayoutContext, DialogModesEnum } from '../';

export interface QrLinkProps {
    qrSize?: number;
    logoImage?: string;
    value: string;
    title?: string | null;
}

const QrLink = (props: QrLinkProps) => {
    const { t } = useTranslation();

    const layoutContext = useContext(LayoutContext) as ILayoutContext;

    const qrSize = props.qrSize ?? 128;
    const title = props.title ?? " ";

    const onClickQr = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();

        const shortUrl =
            props.value
                .replace("https://www.", "")
                .replace("http://www.", "")
                .replace("https://", "")
                .replace("http://", "");

        layoutContext.dialog.show({
            title: title,
            className: "qr-link-modal",
            content: (<>
                <div className="qr-container">
                    <QRCode {...props} size={qrSize}
                        logoWidth={qrSize * 0.4} />
                </div>

                <p><small>{shortUrl}</small></p>
            </>),
            mode: DialogModesEnum.standard
        });
    }

    const onClickUrl = () => {
        window.open(props.value);
    }

    return (
        <div className="qr-link" onClick={onClickUrl}>
            <span>{props.value}</span>

            <Tooltip title={t("click-to-view-qr")}>
                <div className="qr-container" onClick={onClickQr}>
                    <QRCode size={qrSize}
                        logoWidth={qrSize * 0.4} />
                </div>
            </Tooltip>
        </div>
    );
}

export default QrLink;